<script setup lang="ts">
import { capitalize } from "vue";

const { t } = useI18n();

useSeoMeta({
	title: () => t("meta.about.title"),
	ogTitle: () => t("meta.about.ogTitle"),
	description: () => t("meta.about.description"),
	ogDescription: () => t("meta.about.ogDescription")
});
</script>

<template>
	<section class="box-content pt-10 px-4 max-w-[1400px] m-auto">
		<h1 class="max-w-[1024px] m-auto font-bold text-3xl uppercase ">
			{{ $t('aboutTitle') }}
		</h1>
		<article class="mt-6">
			<!-- <div class="h-[550px] bg-orange-light"></div> -->
			<div class="mt-8 max-w-[930px] m-auto">
				<p class="font-medium text-2xl uppercase">
					{{ $t('aboutTitle2') }}
				</p>
				<p class="font-medium text-2xl uppercase">
					{{ $t('aboutTitle3') }}
				</p>
				<p class="mt-3">
					<b class="font-medium text-lg">{{ $t('aboutDescription') }}</b>
				</p>
				<p class="mt-4 text-sm">
					{{ $t('aboutDescription2') }}
				</p>
				<div class="mt-6 flex gap-x-6">
					<div class="flex flex-col gap-y-1">
						<p class="font-medium text-lg">
							🍰 {{ $t('aboutFeature') }}
						</p>
						<p class="font-medium text-lg">
							🚚 {{ $t('aboutFeature2') }}
						</p>
						<p class="font-medium text-lg">
							📦 {{ $t('aboutFeature3') }}
						</p>
					</div>
					<div class="flex flex-col gap-y-1">
						<p class="font-medium text-lg">
							🤍 {{ $t('aboutFeature4') }}
						</p>
						<p class="font-medium text-lg">
							🤍 {{ $t('aboutFeature5') }}
						</p>
						<p class="font-medium text-lg">
							🤍 {{ $t('aboutFeature6') }}
						</p>
					</div>
				</div>
			</div>
			<div class="mt-6 max-w-[1280px] m-auto flex gap-x-7 gap-y-7 sm:flex-wrap xs:flex-wrap sm:justify-center xs:justify-center">
				<NuxtImg
					class="max-w-[570px] max-h-[570px] w-full h-full"
					src="img/about.webp"
					:width="570"
					:height="570"
					alt="image"
				/>
				<div class="mt-6 sm:mt-4 xs:mt-4">
					<h3 class="font-medium text-lg uppercase text-green-dark">
						{{ $t('aboutFooterTitle') }}
					</h3>
					<p class="mt-2 text-sm">
						{{ capitalize($t('aboutFooterDescription')) }}
					</p>
				</div>
			</div>
		</article>
		<CommonAdvantages class="py-11 max-w-[1280px] m-auto" />
	</section>
</template>
